import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AccountingPeriodType} from "../../enums/accounting-period-type";

@Injectable({
  providedIn: 'root'
})
export class AccountingPeriodsService {
  private apiurl = '';

  constructor(private http: HttpClient) {
    this.apiurl = environment.api + 'app/v1/accounting/periods/';
  }

  findPastPeriods(type: string) {
    return this.http.get(this.apiurl + type + '/past')
  }

  findAccountablePeriod(type: string) {
    return this.http.get(this.apiurl + type + '/accountable')
  }

}
